<div class="container-fluid">
    <div class="row">
      <div class="col-md-3">
        <a routerLink="/naac/dvv/criteria5"> <i class="fas fa-long-arrow-alt-left"></i> Go Back</a>
        <nav id="secondary-navigation">
          <!-- Header -->
          <header class="header">
            <h5>5.1.2</h5>
          </header>
          <!-- /Header -->
          <ul>
            <li class="one">
              <a (click)="changeRoute('1')">Reports  of the events_5 years_1</a>
            </li>
            <li class="two">
              <a (click)="changeRoute('2')">Photosgraphs of the events_5 Years_2</a>
            </li>
            <li class="three">
              <a (click)="changeRoute('3')">Attendance sheet with signature of students_5Years_4</a>
            </li>
            <li class="four">
              <a (click)="changeRoute('4')">Certificates _Lang_Yoga_ICT_Add-on Courses_5 years_5</a>
            </li>
            <li class="five">
              <a (click)="changeRoute('5')">List of students who received certificates_5Years_5 (A)</a>
            </li>
          </ul>
        </nav>
      </div>
      <div class="col-md-9">
        <div id="five-one-one">
          <div class="container-fluid">
            <div class="row">
              <div class="col-12">
                <div class="card shadow-lg">
                  <h4 class="card-title text-center" >{{selectedValue.name}}</h4>
                  <div class="card-body text-justify">
                    <div id="detail" class="text-center">
                      <pdf-viewer [src]="selectedValue.src" [render-text]="true" style="display: block;" id="list-view"></pdf-viewer>
                  </div>
                  </div>
                </div>
  
              </div>
            </div>
  
  
          </div>
        </div>
      </div>
    </div>
  </div>